import { type GeocodingResult } from '@google/maps'
import Axios from 'axios'
import config from '../config'

const key = config.googleMapsKey
const geocodeUrl = 'https://maps.googleapis.com/maps/api/geocode/json'
const placeDetailsUrl =
  'https://maps.googleapis.com/maps/api/place/details/json'

export interface PlaceDetailsResult {
  formatted_address?: string
  name?: string
  place_id?: string
  geometry?: {
    location: {
      lat: number
      lng: number
    }
  }
  address_components?: {
    long_name: string
    short_name: string
    types: string[]
  }[]
}

export class GeoCodingService {
  //private readonly geoCoder: GoogleMapsClient

  public async geocodeAddress(address: string): Promise<GeocodingResult[]> {
    const response = await Axios.get<{
      results: GeocodingResult[]
      status: string
    }>(geocodeUrl, {
      params: { key, address },
    })

    return response.data.results
  }
}

/**
 * Fetches place details from the Google Places API.
 *
 * Uses the REST API - will incur CORS errors.
 * For browser-based requests, use the `usePlaceDetails` hook instead
 *
 */
export async function getPlaceDetails(
  placeId: string
): Promise<PlaceDetailsResult | null> {
  try {
    const response = await Axios.get<{
      result: PlaceDetailsResult
      status: string
    }>(placeDetailsUrl, {
      params: {
        key,
        place_id: placeId,
        fields: 'formatted_address,name,place_id,geometry,address_components',
      },
    })

    if (response.data.status === 'OK') {
      return response.data.result
    }

    return null
  } catch {
    return null
  }
}
